// Which roster Studio Manage Reviews shows: the viewer's own (/accounts/:id/reviews/sent) or the
// organization's (/organizations/:id/review/sent).
export const REVIEW_ROSTER_SCOPES = {
  MINE: 'mine',
  ORGANIZATION: 'organization'
} as const;

export type ReviewRosterScope = (typeof REVIEW_ROSTER_SCOPES)[keyof typeof REVIEW_ROSTER_SCOPES];
